module.exports = __webpack_public_path__ + "static/media/dash-billpay.912fe5d8.svg";